import { Component, ElementRef, NgZone, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { PhoneService, IPhoneCall } from '@wephone-app-phone/services';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { MessageService, Platform } from '@wephone-utils';
import { FlexIvrSettings } from '@wephone-core/wephone-core.module';

const SMALL_WIDTH_BREAKPOINT = 960;

@Component({
  selector: 'phone-layout',
  templateUrl: './phone-layout.component.html',
  styleUrls: ['./phone-layout.component.scss']
})
export class PhoneLayoutComponent implements OnInit, OnDestroy {
  private _router: Subscription;

  mediaMatcher: MediaQueryList = matchMedia(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`);
  url: string;
  sidePanelOpened;
  options = {
    collapsed: false,
    compact: false,
    boxed: false,
    dark: false,
    dir: 'ltr'
  };

  @ViewChild('sidemenu', { static: false }) sidemenu: MatSidenav;
  @ViewChild(PerfectScrollbarDirective, { static: false }) directiveScroll: PerfectScrollbarDirective;

  loadNotification = false;

  public config: PerfectScrollbarConfigInterface = {};

  inBrowser: boolean;
  safeUrl: any;

  constructor(
    private readonly _element: ElementRef,
    private readonly router: Router,
    private readonly routeSnapshot: ActivatedRoute,
    private readonly phoneService: PhoneService,
    private readonly authService: AuthenticationService,
    zone: NgZone,
    private readonly platform: Platform,
    private readonly messageService: MessageService,
    private readonly settings: FlexIvrSettings,
  ) {
    /*
    this.mediaMatcher.addListener(mql =>
      zone.run(() => {
        this.mediaMatcher = mql;
      })
    );
*/
    // this.inBrowser = this.platform.isDesktop() && !this.platform.isElectronApp();
    this.messageService.subscribe('phone:open_bo_url', res => {
      if (window.self !== window.top) {
        window.parent.postMessage({ function: 'graam_post_msg.open_bo_url', url: res }, settings.root_url);
      } else {
        window.open(res, 'graam_bo');
      }
    });
  }

  ngOnInit(): void {
    this.url = this.router.url;

    this._router = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // document.querySelector('.app-inner > .mat-drawer-content > div').scrollTop = 0;
        this.url = event.url;
        this.runOnRouteChange();
      });
  }

  ngOnDestroy(): void {
    this._router.unsubscribe();
  }

  runOnRouteChange(): void {
    // console.log('runOnRouteChange: ', this.routeSnapshot.url, this.routeSnapshot.data);
    if (this.isOver()) {
      this.sidemenu.close();
    }

    this.updatePS();
  }

  receiveOptions($event): void {
    this.options = $event;
  }

  isOver(): boolean {
    if (
      this.url === '/apps/messages' ||
      this.url === '/apps/calendar' ||
      this.url === '/apps/media' ||
      this.url === '/maps/leaflet' ||
      this.url === '/taskboard'
    ) {
      return true;
    }

    return this.mediaMatcher.matches;
  }

  menuMouseOver(): void {
    if (this.mediaMatcher.matches && this.options.collapsed) {
      this.sidemenu.mode = 'over';
    }
  }

  menuMouseOut(): void {
    if (this.mediaMatcher.matches && this.options.collapsed) {
      this.sidemenu.mode = 'side';
    }
  }

  updatePS(): void {
    if (!this.mediaMatcher.matches && !this.options.compact) {
      setTimeout(() => {
        this.directiveScroll.update();
      }, 350);
    }
  }

  get activeCall(): IPhoneCall {
    return this.phoneService.getActiveCall();
  }

  showNotification(isOpen: boolean): void {
    this.loadNotification = isOpen;
  }

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  hideBOUrl(): void {
    this.safeUrl = undefined;
  }
}
